module.exports = __webpack_public_path__ + "media/src/public/img/android-chrome-192x192-4caa455754f3b4b8dc79095806c1e50a.png";